import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function CheckboxChecked(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" fill="currentColor" />
        <path d="M6 10.0001L8.82843 12.8285L14.4847 7.17163" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
}
